import { __assign, __read, __rest, __spread } from "tslib";
import classNames from "classnames";
import React from "react";
import { Select } from "../../../select";
import { useConfig } from "../../../_util/config-context";
export function SingleFilterButton(_a) {
    var all = _a.all, className = _a.className, style = _a.style, children = _a.children, options = _a.options, value = _a.value, selectProps = __rest(_a, ["all", "className", "style", "children", "options", "value"]);
    var classPrefix = useConfig().classPrefix;
    var active = Boolean(value);
    if (all) {
        options = __spread([all], options); // eslint-disable-line no-param-reassign
        active = value !== all.value;
    }
    return (React.createElement("span", { className: classNames(classPrefix + "-table__filterbtn", { "is-active": active }, className), style: style },
        React.createElement(Select, __assign({}, selectProps, { type: "simulate", appearance: "filter", button: children, options: options.map(function (_a) {
                var label = _a.label, text = _a.text, option = __rest(_a, ["label", "text"]);
                return (__assign(__assign({}, option), { text: text || label }));
            }), value: value }))));
}
//# sourceMappingURL=SingleFilterButton.js.map